(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-tabs"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (section) => {
      if (section.dataset.fctReady === 'true') return;
      section.dataset.fctReady = 'true';
      const tabs = Array.from(section.querySelectorAll('[data-fct-tab]'));
      const panels = Array.from(section.querySelectorAll('[data-fct-panel]'));
      const setupScroller = (wrap) => {
        if (wrap.dataset.fctScrollerReady === 'true') return;
        wrap.dataset.fctScrollerReady = 'true';
        const track = wrap.querySelector('[data-fct-scroll-track]');
        const previous = wrap.querySelector('[data-fct-scroll-prev]');
        const next = wrap.querySelector('[data-fct-scroll-next]');
        if (!track) return;
        const canScroll = () => track.scrollWidth > track.clientWidth + 2;
        const updateButtons = () => {
          const scrollable = canScroll();
          track.classList.toggle('is-scrollable', scrollable);
          if (!previous || !next) return;
          previous.hidden = !scrollable;
          next.hidden = !scrollable;
          if (!scrollable) return;
          previous.classList.toggle('is-disabled', track.scrollLeft <= 2);
          next.classList.toggle('is-disabled', track.scrollLeft + track.clientWidth >= track.scrollWidth - 2);
        };
        const scrollByCard = (direction) => {
          const card = track.querySelector('.fct__item');
          const styles = window.getComputedStyle(track);
          const gap = parseFloat(styles.columnGap || styles.gap) || 0;
          const amount = card ? card.getBoundingClientRect().width + gap : track.clientWidth * .8;
          track.scrollBy({ left: direction * amount, behavior: 'smooth' });
        };
        if (previous && next) {
          previous.addEventListener('click', () => scrollByCard(-1));
          next.addEventListener('click', () => scrollByCard(1));
        }
        track.addEventListener('scroll', updateButtons, { passive: true });
        window.addEventListener('resize', updateButtons);
        updateButtons();
        setTimeout(updateButtons, 350);
      };
      const updatePanelScrollers = () => {
        section.querySelectorAll('[data-fct-scroll-wrap]').forEach((wrap) => {
          setupScroller(wrap);
          const track = wrap.querySelector('[data-fct-scroll-track]');
          if (track) track.dispatchEvent(new Event('scroll'));
        });
      };
      const activate = (tab) => {
        tabs.forEach((item) => {
          const active = item === tab;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', active ? 'true' : 'false');
          item.tabIndex = active ? 0 : -1;
        });
        panels.forEach((panel) => {
          const active = panel.id === tab.getAttribute('aria-controls');
          panel.hidden = !active;
          panel.classList.toggle('is-active', active);
        });
        requestAnimationFrame(updatePanelScrollers);
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab));
        tab.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          const offset = event.key === 'ArrowRight' ? 1 : -1;
          const next = tabs[(index + offset + tabs.length) % tabs.length];
          activate(next);
          next.focus();
        });
      });
      updatePanelScrollers();
    };
    const initAll = (root = document) => root.querySelectorAll('[data-feohwynn-collection-tabs]').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
    else initAll();
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feohwynn-article-page"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-feohwynn-article]').forEach((section) => {
    const content = section.querySelector('[data-article-content]');
    const toc = section.querySelector('[data-article-toc]');
    const list = section.querySelector('[data-article-toc-list]');
    if (!content) return;

    const markerName = (element) => {
      if (!element || element.querySelector('img, iframe, video')) return '';
      const match = element.textContent.trim().toUpperCase().match(/^\[([A-ZÄÖÜ ]+)\]$/);
      return match ? match[1].replace(/\s+/g, ' ') : '';
    };
    const groupedCommands = new Map([
      ['BILD LINKS', 'image-left'],
      ['BILD RECHTS', 'image-right'],
      ['BILD BREIT', 'wide-image'],
      ['GALERIE', 'gallery'],
      ['PERGAMENT', 'panel'],
      ['REISEBUCH', 'journal'],
      ['BRIEF', 'letter'],
      ['FAKTEN', 'facts'],
      ['ZEITLEISTE', 'timeline'],
      ['WEGWEISER', 'wayfinder'],
      ['AUFKLAPPEN', 'reveal'],
      ['KARTE', 'map'],
      ['KAPITELAUFTAKT', 'chapter'],
      ['PERSON', 'person'],
      ['BESTIARIUM', 'bestiary'],
      ['DIALOG', 'dialogue'],
      ['VERGLEICH', 'comparison']
    ]);
    const safeLink = (value) => {
      const url = value.trim();
      if (url.startsWith('/') || url.startsWith('#') || url.startsWith('https://') || url.startsWith('http://')) return url;
      return '';
    };
    const makeModule = (type, nodes) => {
      if (type === 'image-left' || type === 'image-right') {
        const imageNode = nodes.find((node) => node.matches('img') || node.querySelector('img'));
        if (!imageNode) return null;
        const wrapper = document.createElement('section');
        wrapper.className = `fap__module fap__module--image fap__module--${type}`;
        const media = document.createElement('div');
        media.className = 'fap__module-media';
        const copy = document.createElement('div');
        copy.className = 'fap__module-copy';
        nodes.forEach((node) => (node === imageNode ? media : copy).appendChild(node));
        wrapper.append(media, copy);
        return wrapper;
      }
      if (type === 'facts') {
        const wrapper = document.createElement('section');
        wrapper.className = 'fap__module fap__module--facts';
        const list = document.createElement('dl');
        list.className = 'fap__facts';
        nodes.forEach((node) => {
          const text = node.textContent.trim();
          const divider = text.indexOf(':');
          if (divider < 1) return;
          const row = document.createElement('div');
          const term = document.createElement('dt');
          const description = document.createElement('dd');
          term.textContent = text.slice(0, divider).trim();
          description.textContent = text.slice(divider + 1).trim();
          row.append(term, description);
          list.appendChild(row);
        });
        if (!list.children.length) return null;
        nodes.forEach((node) => node.remove());
        wrapper.appendChild(list);
        return wrapper;
      }
      if (type === 'timeline') {
        const wrapper = document.createElement('section');
        wrapper.className = 'fap__module fap__module--timeline';
        const list = document.createElement('ol');
        list.className = 'fap__timeline';
        nodes.forEach((node) => {
          const text = node.textContent.trim();
          const divider = text.indexOf('|');
          if (divider < 1) return;
          const item = document.createElement('li');
          const time = document.createElement('span');
          const copy = document.createElement('span');
          time.className = 'fap__timeline-time';
          copy.className = 'fap__timeline-copy';
          time.textContent = text.slice(0, divider).trim();
          copy.textContent = text.slice(divider + 1).trim();
          item.append(time, copy);
          list.appendChild(item);
        });
        if (!list.children.length) return null;
        nodes.forEach((node) => node.remove());
        wrapper.appendChild(list);
        return wrapper;
      }
      if (type === 'wayfinder') {
        const wrapper = document.createElement('nav');
        wrapper.className = 'fap__module fap__wayfinder';
        wrapper.setAttribute('aria-label', 'Weiterreisen');
        nodes.forEach((node) => {
          const existingLink = node.querySelector && node.querySelector('a[href]');
          const text = node.textContent.trim();
          const divider = text.lastIndexOf('|');
          const link = document.createElement('a');
          if (existingLink) {
            link.href = existingLink.href;
            link.textContent = existingLink.textContent.trim();
          } else if (divider > 0) {
            const href = safeLink(text.slice(divider + 1));
            if (!href) return;
            link.href = href;
            link.textContent = text.slice(0, divider).trim();
          } else {
            return;
          }
          wrapper.appendChild(link);
        });
        nodes.forEach((node) => node.remove());
        return wrapper.children.length ? wrapper : null;
      }
      if (type === 'reveal') {
        if (!nodes.length) return null;
        const titleNode = nodes.shift();
        const details = document.createElement('details');
        details.className = 'fap__module fap__reveal';
        const summary = document.createElement('summary');
        summary.textContent = titleNode.textContent.trim() || 'Mehr erfahren';
        titleNode.remove();
        const body = document.createElement('div');
        body.className = 'fap__reveal-body';
        nodes.forEach((node) => body.appendChild(node));
        details.append(summary, body);
        return details;
      }
      if (type === 'map' || type === 'chapter') {
        const imageNode = nodes.find((node) => node.matches('img') || node.querySelector('img'));
        if (!imageNode) return null;
        if (type === 'chapter') {
          const titleNode = nodes.find((node) => node !== imageNode && node.textContent.trim());
          if (titleNode && titleNode.tagName !== 'H2') {
            const heading = document.createElement('h2');
            heading.innerHTML = titleNode.innerHTML;
            nodes[nodes.indexOf(titleNode)] = heading;
            titleNode.replaceWith(heading);
          }
        }
        const wrapper = document.createElement('section');
        wrapper.className = `fap__module fap__module--${type}`;
        const copy = document.createElement('div');
        copy.className = type === 'map' ? 'fap__map-copy' : 'fap__chapter-copy';
        nodes.forEach((node) => (node === imageNode ? wrapper : copy).appendChild(node));
        wrapper.appendChild(copy);
        return wrapper;
      }
      if (type === 'person' || type === 'bestiary') {
        const imageNode = nodes.find((node) => node.matches('img') || node.querySelector('img'));
        if (!imageNode) return null;
        const wrapper = document.createElement('section');
        wrapper.className = `fap__module fap__module--profile fap__module--${type}`;
        const media = document.createElement('div');
        media.className = 'fap__profile-media';
        const copy = document.createElement('div');
        copy.className = 'fap__profile-copy';
        nodes.forEach((node) => (node === imageNode ? media : copy).appendChild(node));
        wrapper.append(media, copy);
        return wrapper;
      }
      if (type === 'dialogue') {
        const wrapper = document.createElement('section');
        wrapper.className = 'fap__module fap__dialogue';
        nodes.forEach((node) => {
          const text = node.textContent.trim();
          const divider = text.indexOf(':');
          if (divider < 1) return;
          const line = document.createElement('div');
          line.className = 'fap__dialogue-line';
          const speaker = document.createElement('span');
          speaker.className = 'fap__dialogue-speaker';
          speaker.textContent = text.slice(0, divider).trim();
          const copy = document.createElement('div');
          copy.className = 'fap__dialogue-copy';
          copy.textContent = text.slice(divider + 1).trim();
          line.append(speaker, copy);
          wrapper.appendChild(line);
        });
        nodes.forEach((node) => node.remove());
        return wrapper.children.length ? wrapper : null;
      }
      if (type === 'comparison') {
        const wrapper = document.createElement('section');
        wrapper.className = 'fap__module fap__comparison';
        nodes.forEach((node, index) => {
          const text = node.textContent.trim();
          const divider = text.indexOf('|');
          if (divider < 1) return;
          [text.slice(0, divider), text.slice(divider + 1)].forEach((value) => {
            const cell = document.createElement('div');
            cell.className = `fap__comparison-cell${index === 0 ? ' fap__comparison-cell--heading' : ''}`;
            cell.textContent = value.trim();
            wrapper.appendChild(cell);
          });
        });
        nodes.forEach((node) => node.remove());
        return wrapper.children.length >= 2 ? wrapper : null;
      }
      const wrapper = document.createElement('section');
      wrapper.className = `fap__module fap__module--${type}`;
      nodes.forEach((node) => wrapper.appendChild(node));
      return wrapper;
    };

    Array.from(content.children).forEach((element) => {
      if (element.parentElement !== content) return;
      const command = markerName(element);
      if (command === 'SZENENWECHSEL') {
        const divider = document.createElement('div');
        divider.className = 'fap__scene-break';
        divider.setAttribute('role', 'separator');
        divider.innerHTML = '<span aria-hidden="true">◆</span>';
        element.replaceWith(divider);
        return;
      }
      const type = groupedCommands.get(command);
      if (!type) return;
      const nodes = [];
      let cursor = element.nextElementSibling;
      while (cursor && markerName(cursor) !== 'ENDE') {
        nodes.push(cursor);
        cursor = cursor.nextElementSibling;
      }
      if (!cursor || !nodes.length) return;
      const module = makeModule(type, nodes);
      if (!module) return;
      element.replaceWith(module);
      cursor.remove();
    });

    Array.from(content.children).forEach((element) => {
      if (element.tagName !== 'P') return;
      const meaningfulChildren = Array.from(element.children).filter((child) => child.tagName !== 'BR');
      if (meaningfulChildren.length !== 1 || meaningfulChildren[0].tagName !== 'STRONG') return;
      if (element.textContent.trim().length > 90) return;
      const heading = document.createElement('h2');
      heading.innerHTML = meaningfulChildren[0].innerHTML;
      element.replaceWith(heading);
    });

    const introParagraph = Array.from(content.children).find((element) => {
      if (element.tagName !== 'P' || !element.textContent.trim()) return false;
      return !element.querySelector('img, iframe, video, strong');
    });
    if (introParagraph) {
      introParagraph.classList.add('fap__intro-paragraph');
      if (section.classList.contains('fap--drop-cap') && !introParagraph.querySelector('.fap__drop-cap')) {
        const walker = document.createTreeWalker(introParagraph, NodeFilter.SHOW_TEXT);
        let firstTextNode = walker.nextNode();
        while (firstTextNode && !firstTextNode.textContent.trim()) firstTextNode = walker.nextNode();
        if (firstTextNode) {
          const firstCharacterIndex = firstTextNode.textContent.search(/\S/);
          const initial = firstTextNode.textContent.charAt(firstCharacterIndex);
          firstTextNode.textContent = firstTextNode.textContent.slice(0, firstCharacterIndex) + firstTextNode.textContent.slice(firstCharacterIndex + 1);
          const dropCap = document.createElement('span');
          dropCap.className = 'fap__drop-cap';
          dropCap.setAttribute('aria-hidden', 'true');
          dropCap.textContent = initial;
          introParagraph.prepend(dropCap);
        }
      }
    }

    if (!toc || !list) return;
    const headings = Array.from(content.querySelectorAll('h2'));
    if (!headings.length) return;
    headings.forEach((heading, index) => {
      if (!heading.id) heading.id = `kapitel-${index + 1}`;
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent;
      item.appendChild(link);
      list.appendChild(item);
    });
    toc.setAttribute('aria-busy', 'false');
    toc.hidden = false;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feohwynn-blog-highlights"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const setupScroller = (wrap) => {
      if (wrap.dataset.fbhScrollerReady === 'true') return;
      wrap.dataset.fbhScrollerReady = 'true';

      const track = wrap.querySelector('[data-fbh-scroll-track]');
      const previous = wrap.querySelector('[data-fbh-scroll-prev]');
      const next = wrap.querySelector('[data-fbh-scroll-next]');
      if (!track) return;

      const canScroll = () => track.scrollWidth > track.clientWidth + 2;

      const updateButtons = () => {
        const scrollable = canScroll();
        track.classList.toggle('is-scrollable', scrollable);
        if (!previous || !next) return;
        previous.hidden = !scrollable;
        next.hidden = !scrollable;
        if (!scrollable) return;
        previous.classList.toggle('is-disabled', track.scrollLeft <= 2);
        next.classList.toggle('is-disabled', track.scrollLeft + track.clientWidth >= track.scrollWidth - 2);
      };

      const scrollByCard = (direction) => {
        const card = track.querySelector('.fbh__card');
        const styles = window.getComputedStyle(track);
        const gap = parseFloat(styles.columnGap || styles.gap) || 0;
        const amount = card ? card.getBoundingClientRect().width + gap : track.clientWidth * .8;
        track.scrollBy({ left: direction * amount, behavior: 'smooth' });
      };

      if (previous && next) {
        previous.addEventListener('click', () => scrollByCard(-1));
        next.addEventListener('click', () => scrollByCard(1));
      }

      track.addEventListener('scroll', updateButtons, { passive: true });
      window.addEventListener('resize', updateButtons);
      updateButtons();
      setTimeout(updateButtons, 350);
    };

    const init = (root = document) => {
      root.querySelectorAll('[data-feohwynn-blog-highlights]').forEach((section) => {
        if (section.dataset.fbhReady === 'true') return;
        section.dataset.fbhReady = 'true';
        section.querySelectorAll('[data-fbh-scroll-wrap]').forEach(setupScroller);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init());
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feohwynn-buchmagie-atmosphere"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function syncBuchmagieAtmosphere() {
      var section = document.querySelector('.fbm-atmosphere');
      var enabled = Boolean(section);
      document.body.classList.toggle('fbm-page', enabled);
      document.body.classList.toggle('fbm-reduced-motion', enabled && section.dataset.fbmMotion !== 'true');
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', syncBuchmagieAtmosphere);
    } else {
      syncBuchmagieAtmosphere();
    }

    document.addEventListener('shopify:section:load', syncBuchmagieAtmosphere);
    document.addEventListener('shopify:section:unload', function () {
      window.setTimeout(syncBuchmagieAtmosphere, 0);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feohwynn-knowledge"] && !Shopify.designMode) return;
  try {
    
(function () {
  var mobileQuery = window.matchMedia('(max-width: 767px)');

  function getParts(section) {
    return {
      cardsWrap: section.querySelector('.feohwynn-knowledge__cards'),
      panelsWrap: section.querySelector('.feohwynn-knowledge__panels'),
      cards: Array.prototype.slice.call(section.querySelectorAll('[data-feohwynn-knowledge-card]')),
      panels: Array.prototype.slice.call(section.querySelectorAll('[data-feohwynn-knowledge-panel]'))
    };
  }

  function panelForCard(section, card) {
    var targetId = card.getAttribute('data-target');
    return section.querySelector('#' + targetId);
  }

  function setState(card, panel, active, isMobile) {
    card.classList.toggle('is-active', active);

    if (isMobile) {
      card.removeAttribute('role');
      card.removeAttribute('aria-selected');
      card.setAttribute('aria-expanded', active ? 'true' : 'false');
      if (panel) {
        panel.removeAttribute('role');
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
      }
      return;
    }

    card.setAttribute('role', 'tab');
    card.setAttribute('aria-selected', active ? 'true' : 'false');
    card.removeAttribute('aria-expanded');

    if (panel) {
      panel.setAttribute('role', 'tabpanel');
      panel.hidden = !active;
      panel.classList.toggle('is-active', active);
    }
  }

  function activateDesktop(section, card) {
    var parts = getParts(section);

    parts.cards.forEach(function (item) {
      var active = item === card;
      setState(item, panelForCard(section, item), active, false);
    });
  }

  function closeAllDesktop(exceptSection) {
    Array.prototype.slice.call(document.querySelectorAll('[data-feohwynn-knowledge]')).forEach(function (itemSection) {
      if (itemSection === exceptSection) return;
      var parts = getParts(itemSection);
      parts.cards.forEach(function (item) {
        setState(item, panelForCard(itemSection, item), false, false);
      });
    });
  }

  function toggleDesktop(section, card) {
    var wasActive = card.classList.contains('is-active');
    closeAllDesktop(section);

    if (wasActive) {
      setState(card, panelForCard(section, card), false, false);
      return;
    }

    activateDesktop(section, card);
  }

  function toggleMobile(section, card) {
    var panel = panelForCard(section, card);
    var active = !card.classList.contains('is-active');
    setState(card, panel, active, true);
  }

  function syncLayout(section) {
    var parts = getParts(section);
    var isMobile = mobileQuery.matches;

    if (!parts.cardsWrap || !parts.panelsWrap || parts.cards.length === 0) return;

    if (isMobile) {
      parts.cardsWrap.removeAttribute('role');
      parts.cardsWrap.removeAttribute('aria-label');

      parts.cards.forEach(function (card) {
        var panel = panelForCard(section, card);
        if (panel && panel.previousElementSibling !== card) {
          card.insertAdjacentElement('afterend', panel);
        }
      });

      if (section.dataset.feohwynnKnowledgeMobileInitialized !== 'true') {
        var openFirst = section.dataset.openFirstMobile !== 'false';
        parts.cards.forEach(function (card, index) {
          setState(card, panelForCard(section, card), openFirst && index === 0, true);
        });
        section.dataset.feohwynnKnowledgeMobileInitialized = 'true';
        return;
      }

      parts.cards.forEach(function (card) {
        setState(card, panelForCard(section, card), card.classList.contains('is-active'), true);
      });

      return;
    }

    parts.cardsWrap.setAttribute('role', 'tablist');
    parts.cardsWrap.setAttribute('aria-label', parts.cardsWrap.getAttribute('data-tabs-label') || 'Wissensbereich');

    parts.panels.forEach(function (panel) {
      if (panel.parentNode !== parts.panelsWrap) {
        parts.panelsWrap.appendChild(panel);
      }
    });

    var activeCard = parts.cards.filter(function (card) {
      return card.classList.contains('is-active');
    })[0];

    if (!activeCard && section.dataset.openFirstDesktop === 'true') {
      activeCard = parts.cards[0];
    }

    if (!activeCard) {
      parts.cards.forEach(function (card) {
        setState(card, panelForCard(section, card), false, false);
      });
      return;
    }

    activateDesktop(section, activeCard);
  }

  function init(section) {
    if (!section || section.dataset.feohwynnKnowledgeReady === 'true') return;
    section.dataset.feohwynnKnowledgeReady = 'true';

    var cards = Array.prototype.slice.call(section.querySelectorAll('[data-feohwynn-knowledge-card]'));

    cards.forEach(function (card, index) {
      card.addEventListener('click', function () {
        if (mobileQuery.matches) {
          toggleMobile(section, card);
          return;
        }
        toggleDesktop(section, card);
      });

      card.addEventListener('keydown', function (event) {
        if (mobileQuery.matches) return;
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        event.preventDefault();
        var direction = event.key === 'ArrowRight' ? 1 : -1;
        var nextIndex = (index + direction + cards.length) % cards.length;
        cards[nextIndex].focus();
        activateDesktop(section, cards[nextIndex]);
      });
    });

    syncLayout(section);
  }

  function initAll(root) {
    Array.prototype.slice.call((root || document).querySelectorAll('[data-feohwynn-knowledge]')).forEach(init);
  }

  function syncAll(root) {
    Array.prototype.slice.call((root || document).querySelectorAll('[data-feohwynn-knowledge]')).forEach(syncLayout);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  if (mobileQuery.addEventListener) {
    mobileQuery.addEventListener('change', function () {
      syncAll(document);
    });
  } else {
    mobileQuery.addListener(function () {
      syncAll(document);
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feohwynn-page-layout"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(section) {
    if (!section || section.dataset.feohwynnPageLayoutReady === 'true') return;
    section.dataset.feohwynnPageLayoutReady = 'true';

    var links = Array.prototype.slice.call(section.querySelectorAll('.feohwynn-page-layout__nav-link[href^="#"]'));
    if (links.length === 0) return;

    links.forEach(function (link) {
      link.addEventListener('click', function () {
        links.forEach(function (item) {
          item.classList.remove('is-active');
        });
        link.classList.add('is-active');
      });
    });
  }

  function initAll(root) {
    Array.prototype.slice.call((root || document).querySelectorAll('.feohwynn-page-layout')).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feohwynn-podcast-overview"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const getPlaylistId = (value) => {
      const rawValue = (value || '').trim();
      if (!rawValue.includes('youtube.com') && !rawValue.includes('youtu.be')) return rawValue;
      try {
        return new URL(rawValue).searchParams.get('list') || '';
      } catch (error) {
        return '';
      }
    };

    const getVideoId = (item) => item.contentDetails?.videoId || item.snippet?.resourceId?.videoId || '';
    const getPublishedTime = (item) => Date.parse(item.contentDetails?.videoPublishedAt || item.snippet?.publishedAt || '') || 0;
    const isAvailable = (item) => {
      const title = item.snippet?.title;
      return getVideoId(item) && title !== 'Deleted video' && title !== 'Private video';
    };
    const getThumb = (snippet, videoId) => snippet.thumbnails?.maxres?.url || snippet.thumbnails?.standard?.url || snippet.thumbnails?.high?.url || `https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`;
    const cleanTitle = (value) => (value || '').replace(/^\s*\d+\s*[-.:–—]?\s*/, '').replace(/\s+(?:#[^\s]+\s*)+$/, '').trim();

    const runMedia = (section, signal) => {
      if (!section || section.dataset.fpoReady === 'true') return;
      section.dataset.fpoReady = 'true';
      const apiKey = section.dataset.apiKey;
      const locale = section.dataset.locale || 'de-DE';
      const cards = Array.from(section.querySelectorAll('[data-podcast-card]'));

      cards.forEach((card) => {
        const media = card.querySelector('[data-latest-media]');
        const title = card.querySelector('[data-latest-title]');
        const meta = card.querySelector('[data-latest-meta]');
        const link = card.querySelector('[data-latest-link]');
        const status = card.querySelector('[data-latest-status]');
        const playlistId = getPlaylistId(card.dataset.playlist);

        const fail = () => {
          media?.setAttribute('aria-busy', 'false');
          if (media) media.innerHTML = '';
          if (title) title.textContent = section.dataset.errorLabel;
          if (status) status.textContent = section.dataset.errorLabel;
        };

        if (!apiKey || !playlistId || !media || !title || !link) {
          fail();
          return;
        }

        const endpoint = new URL('https://www.googleapis.com/youtube/v3/playlistItems');
        endpoint.searchParams.set('part', 'snippet,contentDetails');
        endpoint.searchParams.set('maxResults', '20');
        endpoint.searchParams.set('playlistId', playlistId);
        endpoint.searchParams.set('key', apiKey);

        fetch(endpoint, { signal })
          .then((response) => {
          if (signal.aborted) throw new DOMException('Consent revoked', 'AbortError');
            if (!response.ok) throw new Error('YouTube playlist request failed');
            return response.json();
          })
          .then((data) => {
          if (signal.aborted) throw new DOMException('Consent revoked', 'AbortError');
            const items = (Array.isArray(data.items) ? data.items : []).filter(isAvailable).sort((a, b) => getPublishedTime(b) - getPublishedTime(a));
            if (!items.length) throw new Error('YouTube playlist is empty');
            const item = items[0];
            const snippet = item.snippet || {};
            const videoId = getVideoId(item);
            const image = document.createElement('img');
            const button = document.createElement('button');
            const icon = document.createElement('span');
            const date = new Date(getPublishedTime(item));

            image.src = getThumb(snippet, videoId);
            image.alt = snippet.title || '';
            image.width = 640;
            image.height = 360;
            image.loading = 'lazy';
            button.type = 'button';
            button.className = 'fpo__media-button';
            button.setAttribute('aria-label', `${section.dataset.playLabel}: ${snippet.title || ''}`);
            icon.className = 'fpo__play-icon';
            icon.setAttribute('aria-hidden', 'true');
            icon.textContent = '▶';
            button.append(image, icon);
            button.addEventListener('click', () => {
              const iframe = document.createElement('iframe');
              iframe.src = `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&playsinline=1&rel=0`;
              iframe.title = snippet.title || section.dataset.playLabel;
              iframe.loading = 'lazy';
              iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
              iframe.allowFullscreen = true;
              button.replaceWith(iframe);
            }, { once: true });

            media.replaceChildren(button);
            media.setAttribute('aria-busy', 'false');
            title.textContent = cleanTitle(snippet.title);
            meta.textContent = Number.isNaN(date.getTime()) ? '' : new Intl.DateTimeFormat(locale, { day: '2-digit', month: 'short', year: 'numeric' }).format(date);
            link.href = `https://www.youtube.com/watch?v=${videoId}`;
            link.setAttribute('aria-label', `${section.dataset.playLabel}: ${snippet.title || ''}`);
            if (status) status.textContent = '';
          })
          .catch(() => fail());
      });
    };

    const initialize = (section) => {
      if (!section) return;
      const mount = () => window.FeohwynnMediaConsent?.mount(section, signal => runMedia(section, signal));
      if (window.FeohwynnMediaConsent) mount();
      else document.addEventListener('feohwynn:media-consent-ready', mount, { once: true });
    };

    document.querySelectorAll('[data-podcast-overview]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target.querySelector('[data-podcast-overview]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feohwynn-podcast-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const runMedia = (section, signal) => {
      if (!section || section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';

      const list = section.querySelector('[data-podcast-list]');
      const episodeTemplate = section.querySelector('[data-podcast-episode-template]');
      const latestMedia = section.querySelector('[data-podcast-latest-media]');
      const latestTitle = section.querySelector('[data-podcast-latest-title]');
      const latestMeta = section.querySelector('[data-podcast-latest-meta]');
      const latestDescription = section.querySelector('[data-podcast-latest-description]');
      const latestLink = section.querySelector('[data-podcast-latest-link]');
      const loadMore = section.querySelector('[data-podcast-load-more]');
      const count = section.querySelector('[data-podcast-count]');
      const status = section.querySelector('[data-podcast-status]');
      const tools = section.querySelector('[data-podcast-tools]');
      const search = section.querySelector('[data-podcast-search]');
      const sort = section.querySelector('[data-podcast-sort]');
      const reset = section.querySelector('[data-podcast-reset]');
      const archiveNote = section.querySelector('[data-podcast-archive-note]');
      const apiKey = section.dataset.apiKey.trim();
      const maxVideos = Math.min(Math.max(Number(section.dataset.maxVideos || 24), 1), 50);
      const initialVideos = Math.min(Math.max(Number(section.dataset.initialVideos || 6), 1), maxVideos);
      const loadStep = Math.max(Number(section.dataset.loadStep || 6), 1);
      const locale = section.dataset.locale || 'de-DE';
      let items = [];
      let visibleItems = initialVideos;

      const getPlaylistId = (value) => {
        const rawValue = (value || '').trim();
        if (!rawValue.includes('youtube.com') && !rawValue.includes('youtu.be')) return rawValue;
        try { return new URL(rawValue).searchParams.get('list') || ''; } catch (error) { return ''; }
      };

      const playlistId = getPlaylistId(section.dataset.playlistId);
      if (!list || !episodeTemplate || !playlistId || !apiKey) {
        list?.setAttribute('aria-busy', 'false');
        if (list) list.innerHTML = '';
        if (status) status.textContent = section.dataset.errorMessage;
        return;
      }

      const getVideoId = (item) => item.contentDetails?.videoId || item.snippet?.resourceId?.videoId || '';
      const getPublishedTime = (item) => Date.parse(item.contentDetails?.videoPublishedAt || item.snippet?.publishedAt || '') || 0;
      const isAvailable = (item) => {
        const title = item.snippet?.title;
        return getVideoId(item) && title !== 'Deleted video' && title !== 'Private video';
      };
      const getThumb = (snippet, videoId) => snippet.thumbnails?.maxres?.url || snippet.thumbnails?.standard?.url || snippet.thumbnails?.high?.url || `https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`;
      const formatDate = (item) => {
        const date = new Date(getPublishedTime(item));
        return Number.isNaN(date.getTime()) ? '' : new Intl.DateTimeFormat(locale, { day: '2-digit', month: 'short', year: 'numeric' }).format(date);
      };
      const formatDuration = (value) => {
        if (!value) return '';
        const match = value.match(/PT(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?/);
        if (!match) return '';
        const hours = Number(match[1] || 0);
        const minutes = Number(match[2] || 0);
        const seconds = Number(match[3] || 0);
        return hours ? `${hours}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}` : `${minutes}:${String(seconds).padStart(2, '0')}`;
      };
      const cleanTitle = (value) => (value || '')
        .replace(/^Feohwynn\s+Geschichtenfundus\s*[-–—]\s*(?:Episode|Epsiode)\s*\d+\s*:\s*/i, '')
        .replace(/^\s*\d+\s*[-.:–—]?\s*/, '')
        .replace(/\s+(?:#[^\s]+\s*)+$/, '')
        .trim();
      const createImage = (item, eager = false) => {
        const snippet = item.snippet || {};
        const image = document.createElement('img');
        image.src = getThumb(snippet, getVideoId(item));
        image.alt = snippet.title || '';
        image.width = 640;
        image.height = 360;
        image.loading = eager ? 'eager' : 'lazy';
        if (eager) image.fetchPriority = 'high';
        return image;
      };
      const createIframe = (item, autoplay) => {
        const iframe = document.createElement('iframe');
        iframe.src = `https://www.youtube-nocookie.com/embed/${getVideoId(item)}?playsinline=1&rel=0${autoplay ? '&autoplay=1' : ''}`;
        iframe.title = item.snippet?.title || section.dataset.playLabel;
        iframe.loading = 'lazy';
        iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
        iframe.allowFullscreen = true;
        return iframe;
      };
      const createMediaButton = (item, eager = false) => {
        const button = document.createElement('button');
        const icon = document.createElement('span');
        button.type = 'button';
        button.className = 'fpp__media-button';
        button.setAttribute('aria-label', `${section.dataset.playLabel}: ${item.snippet?.title || ''}`);
        button.appendChild(createImage(item, eager));
        icon.className = 'fpp__play-icon';
        icon.setAttribute('aria-hidden', 'true');
        icon.textContent = '▶';
        button.appendChild(icon);
        button.addEventListener('click', () => button.replaceWith(createIframe(item, true)), { once: true });
        return button;
      };

      const renderLatest = (item) => {
        const snippet = item.snippet || {};
        const date = formatDate(item);
        const duration = formatDuration(item.duration);
        latestMedia.replaceChildren(createMediaButton(item, true));
        latestTitle.textContent = cleanTitle(snippet.title);
        latestMeta.textContent = [date, duration].filter(Boolean).join(' · ');
        latestDescription.textContent = snippet.description || '';
        latestLink.href = `https://www.youtube.com/watch?v=${getVideoId(item)}`;
      };

      const renderEpisode = (item, index) => {
        const snippet = item.snippet || {};
        const videoId = getVideoId(item);
        const card = episodeTemplate.content.firstElementChild.cloneNode(true);
        const play = card.querySelector('[data-episode-play]');
        const thumb = card.querySelector('[data-episode-thumb]');
        const externalLink = card.querySelector('[data-episode-link]');
        thumb.appendChild(createImage(item));
        play.setAttribute('aria-label', `${section.dataset.playLabel}: ${snippet.title || ''}`);
        play.addEventListener('click', () => play.replaceWith(createIframe(item, true)), { once: true });
        card.querySelector('[data-episode-number]').textContent = `${section.dataset.episodePrefix} ${items.length - index}`;
        card.querySelector('[data-episode-title]').textContent = cleanTitle(snippet.title);
        card.querySelector('[data-episode-description]').textContent = snippet.description || '';
        const time = card.querySelector('[data-episode-date]');
        time.textContent = formatDate(item);
        if (getPublishedTime(item)) time.dateTime = new Date(getPublishedTime(item)).toISOString();
        card.querySelector('[data-episode-duration]').textContent = formatDuration(item.duration);
        externalLink.href = `https://www.youtube.com/watch?v=${videoId}`;
        externalLink.setAttribute('aria-label', `${section.dataset.playLabel}: ${snippet.title || ''}`);
        return card;
      };

      const normalizeSearch = (value) => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase(locale).replace(/ß/g, 'ss').trim();
      const getMatches = () => {
        const terms = normalizeSearch(search.value).split(/\s+/).filter(Boolean);
        return items.filter((item) => {
          const text = normalizeSearch(`${item.snippet?.title || ''} ${item.snippet?.description || ''}`);
          return terms.every((term) => text.includes(term));
        }).sort((a, b) => {
          if (sort.value === 'oldest') return getPublishedTime(a) - getPublishedTime(b);
          if (sort.value === 'title') return cleanTitle(a.snippet?.title).localeCompare(cleanTitle(b.snippet?.title), locale, { numeric: true, sensitivity: 'base' });
          return getPublishedTime(b) - getPublishedTime(a);
        });
      };

      const renderList = (append = false) => {
        const matches = getMatches();
        const start = append ? list.children.length : 0;
        const fragment = document.createDocumentFragment();
        matches.slice(start, visibleItems).forEach((item) => fragment.appendChild(renderEpisode(item, items.indexOf(item))));
        if (append) list.appendChild(fragment);
        else list.replaceChildren(fragment);
        list.setAttribute('aria-busy', 'false');
        count.textContent = section.dataset.resultLabel.replace('[shown]', String(Math.min(visibleItems, matches.length))).replace('[total]', String(matches.length));
        status.textContent = matches.length ? '' : section.dataset.emptyLabel;
        reset.hidden = !search.value && sort.value === 'newest';
        loadMore.hidden = visibleItems >= matches.length;
        if (append) list.children[start]?.querySelector('[data-episode-play]')?.focus();
      };

      loadMore?.addEventListener('click', () => {
        visibleItems += loadStep;
        renderList(true);
      });
      search.addEventListener('input', () => { visibleItems = initialVideos; renderList(); });
      sort.addEventListener('change', () => { visibleItems = initialVideos; renderList(); });
      reset.addEventListener('click', () => {
        search.value = '';
        sort.value = 'newest';
        visibleItems = initialVideos;
        renderList();
        search.focus();
      });

      const playlistEndpoint = new URL('https://www.googleapis.com/youtube/v3/playlistItems');
      playlistEndpoint.searchParams.set('part', 'snippet,contentDetails');
      playlistEndpoint.searchParams.set('maxResults', String(maxVideos));
      playlistEndpoint.searchParams.set('playlistId', playlistId);
      playlistEndpoint.searchParams.set('key', apiKey);

      fetch(playlistEndpoint, { signal })
        .then((response) => {
          if (signal.aborted) throw new DOMException('Consent revoked', 'AbortError');
          if (!response.ok) throw new Error('YouTube playlist request failed');
          return response.json();
        })
        .then((data) => {
          if (signal.aborted) throw new DOMException('Consent revoked', 'AbortError');
          if (archiveNote) archiveNote.hidden = !data.nextPageToken;
          items = (Array.isArray(data.items) ? data.items : []).filter(isAvailable).sort((a, b) => getPublishedTime(b) - getPublishedTime(a));
          if (!items.length) throw new Error('YouTube playlist is empty');
          const ids = items.map(getVideoId).join(',');
          const videosEndpoint = new URL('https://www.googleapis.com/youtube/v3/videos');
          videosEndpoint.searchParams.set('part', 'contentDetails');
          videosEndpoint.searchParams.set('id', ids);
          videosEndpoint.searchParams.set('key', apiKey);
          return fetch(videosEndpoint, { signal }).then((response) => response.ok ? response.json() : { items: [] });
        })
        .then((durationData) => {
          if (signal.aborted) throw new DOMException('Consent revoked', 'AbortError');
          const durations = new Map((durationData.items || []).map((video) => [video.id, video.contentDetails?.duration || '']));
          items.forEach((item) => { item.duration = durations.get(getVideoId(item)) || ''; });
          renderLatest(items[0]);
          renderList();
          tools.hidden = false;
        })
        .catch((error) => {
          if (signal.aborted || error.name === 'AbortError') return;
          list.replaceChildren();
          list.setAttribute('aria-busy', 'false');
          status.textContent = section.dataset.errorMessage;
          console.error('Feohwynn podcast page:', error);
        });
    };

    const initializePodcast = (section) => {
      if (!section) return;
      const mount = () => window.FeohwynnMediaConsent?.mount(section, signal => runMedia(section, signal));
      if (window.FeohwynnMediaConsent) mount();
      else document.addEventListener('feohwynn:media-consent-ready', mount, { once: true });
    };

    document.querySelectorAll('[data-podcast-section]').forEach(initializePodcast);
    document.addEventListener('shopify:section:load', (event) => initializePodcast(event.target.querySelector('[data-podcast-section]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["liquid-banner"] && !Shopify.designMode) return;
  try {
    
(function () {
  function updateDots(container, dots) {
    if (!dots.length) return;
    var cards = Array.prototype.slice.call(container.querySelectorAll('[data-liquid-banner-card]'));
    var center = container.scrollLeft + container.clientWidth / 2;
    var closestIndex = 0;
    var closestDistance = Infinity;

    cards.forEach(function (card, index) {
      var childCenter = card.offsetLeft + card.offsetWidth / 2;
      var distance = Math.abs(childCenter - center);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = index;
      }
    });

    dots.forEach(function (dot, index) {
      dot.classList.toggle('active', index === closestIndex);
    });
  }

  function initLiquidBanner(section) {
    if (!section || section.dataset.liquidBannerReady === 'true') return;

    var container = section.querySelector('[data-liquid-banner-container]');
    if (!container) return;

    section.dataset.liquidBannerReady = 'true';

    var arrows = Array.prototype.slice.call(section.querySelectorAll('[data-liquid-banner-arrow]'));
    var dots = Array.prototype.slice.call(section.querySelectorAll('[data-liquid-banner-dot]'));
    var cards = Array.prototype.slice.call(section.querySelectorAll('[data-liquid-banner-card]'));
    var ticking = false;
    section.classList.add('liquid-banner--animating');

    function refresh() {
      var maxScroll = Math.max(0, container.scrollWidth - container.clientWidth);
      var isOverflowing = maxScroll > 2;

      section.classList.toggle('liquid-banner--overflowing', isOverflowing);

      arrows.forEach(function (arrow) {
        var direction = Number(arrow.dataset.direction || 1);
        var disabled = !isOverflowing || (direction < 0 && container.scrollLeft <= 2) || (direction > 0 && container.scrollLeft >= maxScroll - 2);
        arrow.disabled = disabled;
      });

      updateDots(container, dots);
    }

    function requestRefresh() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        refresh();
      });
    }

    arrows.forEach(function (arrow) {
      arrow.addEventListener('click', function () {
        var direction = Number(arrow.dataset.direction || 1);
        var firstCard = cards[0];
        var gap = parseFloat(window.getComputedStyle(container).columnGap || window.getComputedStyle(container).gap || 16) || 16;
        var amount = firstCard ? firstCard.offsetWidth + gap : container.clientWidth * .85;
        container.scrollBy({ left: direction * amount, behavior: 'smooth' });
      });
    });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var index = Number(dot.dataset.index || 0);
        if (!cards[index]) return;
        var scrollPadding = parseFloat(window.getComputedStyle(container).scrollPaddingLeft || 18) || 18;
        container.scrollTo({ left: cards[index].offsetLeft - scrollPadding, behavior: 'smooth' });
      });
    });

    container.addEventListener('scroll', requestRefresh, { passive: true });
    window.addEventListener('resize', requestRefresh);

    if ('ResizeObserver' in window) {
      var observer = new ResizeObserver(requestRefresh);
      observer.observe(container);
      cards.forEach(function (card) {
        observer.observe(card);
      });
    }

    if ('IntersectionObserver' in window) {
      var fadeObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('fade-in-visible');
            fadeObserver.unobserve(entry.target);
          }
        });
      }, { threshold: .1 });

      cards.forEach(function (card) {
        fadeObserver.observe(card);
      });
    } else {
      cards.forEach(function (card) {
        card.classList.add('fade-in-visible');
      });
    }

    refresh();
  }

  function initAll(root) {
    Array.prototype.slice.call((root || document).querySelectorAll('[data-liquid-banner]')).forEach(initLiquidBanner);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('.feohwynn-filter-toggle');
    if (toggle) {
      var layout = toggle.closest('.feohwynn-collection-layout');
      if (!layout) return;

      var collapsed = layout.classList.toggle('filters-collapsed');
      toggle.setAttribute('aria-expanded', collapsed ? 'false' : 'true');

      var label = toggle.querySelector('span');
      if (label) {
        label.textContent = collapsed ? toggle.dataset.labelShow : toggle.dataset.labelHide;
      }
      return;
    }

    var mobileToggle = event.target.closest('.feohwynn-collection-main .btn-filter');
    var mobileClose = event.target.closest('.feohwynn-collection-main .closeFilter');
    if (mobileToggle) {
      window.requestAnimationFrame(function () {
        mobileToggle.setAttribute('aria-expanded', document.documentElement.classList.contains('showOverly') ? 'true' : 'false');
      });
    } else if (mobileClose) {
      var root = mobileClose.closest('.feohwynn-collection-main');
      var opener = root ? root.querySelector('.btn-filter') : null;
      if (opener) opener.setAttribute('aria-expanded', 'false');
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' || !document.documentElement.classList.contains('showOverly')) return;

    document.documentElement.classList.remove('showOverly', 'stopScroll');
    document.querySelectorAll('.feohwynn-collection-main .sb_filter.active').forEach(function (filter) {
      filter.classList.remove('active');
    });
    document.querySelectorAll('.feohwynn-collection-main .btn-filter').forEach(function (button) {
      button.setAttribute('aria-expanded', 'false');
    });
  });

  } catch(e) { console.error(e); }
})();
})();
